module.exports = __webpack_public_path__ + "img/bookmark.6217fecf.svg";